<template>

<div>
        <div class="columns is-vcentered is-centered">
            <div class="column is-12-mobile is-4">
                <div class="box has-text-grey back-gold">
                            <span class="is-pulled-right heart-box">
                                <fa icon="heartbeat" class="has-text-primary heart-beat" v-if="top3[0].is_online" v-tooltip="{ content: 'En Línea' }" />
                                <fa icon="heart-broken" class="has-text-grey" v-tooltip="{ content: 'Desconectado' }" v-else />
                            </span>
                    <div class="media">
                        <div class="media-left">
                            <figure class="image is-64x64">
                                <fa icon="skull" class="has-text-danger-dark fa-4x"/>
                            </figure>
                            <p class="has-text-centered"><small><span v-tooltip="{ content: 'Grand Resets' }">GR:{{top3[0].grandresets}}</span> | <span v-tooltip="{ content: 'Resets' }">R:{{top3[0].resets}}</span></small></p>
                        </div>
                        <div class="media-content has-text-centered is-clipped has-text-justified-mobile">
                            <small v-if="top3[0].guild_detail" class="is-size-7 has-text-primary">[ <fa icon="crown" v-if="top3[0].guild_detail.is_master" v-tooltip="{ content: 'Maestro de Gremio' }" /> {{top3[0].guild_detail.guild.name}} ]</small>
                            <p class="is-size-3-widescreen is-size-4-touch is-size-4-desktop has-text-grey is-marginless">  
                                <b>{{top3[0].name}}</b>
                            </p>
                            <p class="is-size-4 is-size-5-touch has-text-grey is-marginless">{{top3[0].pkcount}} Asesinatos</p>
                            <small>{{charClass(top3[0].class_field)}}</small>
                        </div>
                    </div>
                </div>
            </div>
            <div class="column is-12-mobile is-3" v-if="top3.length > 1">
                <div class="box has-text-grey">
                    <span class="is-pulled-right heart-box">
                        <fa icon="heartbeat" class="has-text-primary heart-beat" v-if="top3[1].is_online" v-tooltip="{ content: 'En Línea' }" />
                        <fa icon="heart-broken" class="has-text-grey" v-tooltip="{ content: 'Desconectado' }" v-else />
                    </span>
                    <div class="media">
                        <div class="media-left">
                        <figure class="image is-48x48">
                            <fa icon="skull" class="has-text-dark fa-3x"/>
                        </figure>
                        <p class="has-text-centered"><small><span v-tooltip="{ content: 'Grand Resets' }">GR:{{top3[1].grandresets}}</span> | <span v-tooltip="{ content: 'Resets' }">R:{{top3[1].resets}}</span></small></p>
                        </div>
                        <div class="media-content has-text-centered is-clipped has-text-justified-mobile">
                            <small v-if="top3[1].guild_detail" class="is-size-7 has-text-primary">[ <fa icon="crown" v-if="top3[1].guild_detail.is_master" v-tooltip="{ content: 'Maestro de Gremio' }" /> {{top3[1].guild_detail.guild.name}} ]</small>
                            <p class="is-size-4-widescreen is-size-4-touch is-size-5-desktop has-text-grey is-marginless"><b>{{top3[1].name}}</b></p>
                            <p class="is-size-5 has-text-grey is-marginless">{{top3[1].pkcount}} Asesinatos</p>
                            <small>{{charClass(top3[1].class_field)}}</small>
                        </div>
                    </div>
                </div>
            </div>
            <div class="column is-12-mobile is-3" v-if="top3.length > 2">
                <div class="box has-text-grey">
                    <span class="is-pulled-right heart-box">
                        <fa icon="heartbeat" class="has-text-primary heart-beat" v-if="top3[2].is_online" v-tooltip="{ content: 'En Línea' }" />
                        <fa icon="heart-broken" class="has-text-grey" v-tooltip="{ content: 'Desconectado' }" v-else />
                    </span>
                    <div class="media">
                        <div class="media-left">
                        <figure class="image is-32x32">
                            <fa icon="skull" class="has-text-grey-light fa-2x"/>
                        </figure>
                        <p class="has-text-centered"><small><span v-tooltip="{ content: 'Grand Resets' }">GR:{{top3[2].grandresets}}</span> | <span v-tooltip="{ content: 'Resets' }">R:{{top3[2].resets}}</span></small></p>
                        </div>
                        <div class="media-content has-text-centered is-clipped has-text-justified-mobile">
                            <small v-if="top3[2].guild_detail" class="is-size-7 has-text-primary">[ <fa icon="crown" v-if="top3[2].guild_detail.is_master" v-tooltip="{ content: 'Maestro de Gremio' }" /> {{top3[2].guild_detail.guild.name}} ]</small>
                            <p class="is-size-5-widescreen is-size-4-touch has-text-grey is-size-5-desktop is-marginless"><b>{{top3[2].name}}</b></p>
                            <p class="is-size-6 is-size-5-touch has-text-grey is-marginless">{{top3[2].pkcount}} Asesinatos</p>
                            <small>{{charClass(top3[2].class_field)}}</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="columns is-vcentered is-centered" v-if="top10.length > 0">
            <div class="column is-2 is-12-mobile" v-for="(char,n) in top10" :key="n">
                <div class="box">
                            <span class="is-pulled-right heart-box">
                                <fa icon="heartbeat" class="has-text-primary heart-beat" v-if="char.is_online" v-tooltip="{ content: 'En Línea' }" />
                                <fa icon="heart-broken" class="has-text-grey" v-tooltip="{ content: 'Desconectado' }" v-else />
                            </span>
                    <small v-if="char.guild_detail" class="is-size-7 has-text-primary is-pulled-left">[ <fa icon="crown" v-if="char.guild_detail.is_master" v-tooltip="{ content: 'Maestro de Gremio' }" /> {{char.guild_detail.guild.name}} ]</small>
                    <br v-if="char.guild_detail">
                    <span class="is-pulled-left">{{char.position}}.</span>
                    <p class="has-text-justified-mobile"> <b>{{char.name}}</b> 
                        <br> {{char.pkcount}} Asesinatos
                        <br><small> <span v-tooltip="{ content: 'Grand Resets' }">GR:{{char.grandresets}}</span> | <span v-tooltip="{ content: 'Resets' }">R:{{char.resets}}</span> </small>
                        <br><small>{{charClass(char.class_field)}}</small></p>
                </div>
            </div>
        </div>
        <div class="card" v-if="top100.length > 0">
            <div class="card-content">
                <div class="table-container">
                    <table class="table is-responsive is-hoverable is-striped is-fullwidth">
                        <thead>
                            <tr>
                            <th>Nro.</th>
                            <th>Nombre</th>
                            <th>Asesinatos</th>
                            <th>Resets</th>
                            <th>Raza</th>
                            <th>Conexión</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(char,n) in top100" :key="n">
                                <td>{{char.position}}</td>
                                <td><span v-if="char.guild_detail" class="has-text-primary">[ <fa icon="crown" v-if="char.guild_detail.is_master" v-tooltip="{ content: 'Maestro de Gremio' }" /> {{char.guild_detail.guild.name}} ]&nbsp;</span><b>{{char.name}}</b></td>
                                <td>{{char.pkcount}}</td>
                                <td>{{char.resets}}</td>
                                <td>{{charClass(char.class_field)}}</td>
                                <td><span class="has-text-primary" v-if="char.is_online">En Línea</span><span v-else class="has-text-grey">Desconectado</span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                </div>
            </div>    
</div>

</template>

<script>
export default {
    name:'RankingPlayers',
    props: {
        top3: {
            type: Array,
            default: ()=>([])
        },
        top10: {
            type: Array,
            default: ()=>([])
        },
        top100: {
            type: Array,
            default: ()=>([])
        }
    },
    computed: {
        charClass() {
            return this.$store.getters.GetCharacterBreed
        }
    },
}
</script>

<style>

</style>